<template>
  <SimpleLoadingChartContainer
    :chart-options="selectedChartOptions"
    :loading="fetchFuelConsumptionDataLoading"
    loading-text="Loading Fuel Consumption Chart..."
  >
    <template #header>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 5px;
        "
      >
        <span class="fuel-consumption-chart-title">Fuel Consumption</span>

        <ThemedRadioGroup
          v-model="selectedChart"
          row
          :value="selectedChart"
        >
          <v-radio value="hfo">
            <template #label>
              <span>{{ hfoLabel }}</span>
            </template>
          </v-radio>

          <v-radio value="lfo">
            <template #label>
              <span>{{ lfoLabel }}</span>
            </template>
          </v-radio>

          <v-radio value="mgo">
            <template #label>
              <span>MGO</span>
            </template>
          </v-radio>
        </ThemedRadioGroup>
      </div>
    </template>
  </SimpleLoadingChartContainer>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import SimpleLoadingChartContainer from "../../../../core/SimpleLoadingChartContainer.vue";
import ThemedRadioGroup from "../../../../core/ThemedRadioGroup.vue";

export default {
  name: "FuelConsumptionChart",

  components: {
    SimpleLoadingChartContainer,
    ThemedRadioGroup,
  },

  data() {
    return {
      selectedChart: "hfo",
    };
  },

  computed: {
    ...mapGetters("vesselInformation/voyageFuelConsumptionDataModule", [
      "hfoChartOptions",
      "mgoChartOptions",
      "lfoChartOptions",
      "mdoChartOptions",
      "robChartOptions",
    ]),

    ...mapState("vesselInformation/voyageFuelConsumptionDataModule", [
      "fetchFuelConsumptionDataLoading",
    ]),

    isCompany5() {
      return process.env.VUE_APP_COMPANY_ID === "5";
    },

    hfoLabel() {
      return this.isCompany5 ? "HSFO" : "HFO";
    },

    lfoLabel() {
      return this.isCompany5 ? "VLSFO" : "LFO";
    },

    selectedChartOptions() {
      if (this.selectedChart === "hfo") return this.hfoChartOptions;
      if (this.selectedChart === "lfo") return this.lfoChartOptions;
      if (this.selectedChart === "mgo") return this.mgoChartOptions;

      return this.lfoChartOptions;
    },
  },
};
</script>

<style scoped>
.fuel-consumption-chart-title {
  color: white;
  font-weight: bold;
}
</style>
